export default "__VITE_ASSET__CcHI0xlh__"